import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { font } from 'assets/themes/theme-default'

import { Button } from '../../index'

const StyledButton = styled(Button)`
  &&& {
    background-color: transparent;
    line-height: unset;

    border-color: ${props => props.theme.colors.color1.bg};
    color: ${props => props.theme.colors.color1.bg};
    span {
      font-size: ${font.size.base};
    }
  }
`

const ButtonPrev = props => {
  const { children } = props

  return (
    <StyledButton {...props} data-test="component-ghost-button">
      {children}
    </StyledButton>
  )
}

ButtonPrev.propTypes = {
  children: PropTypes.any
}

export default ButtonPrev
